import {Component, inject, ViewChild} from '@angular/core';
import {DataGridView, DataGridViewCollumn} from '../../../../Componente/DataGridView';
import {LeitsetlleEdit} from '../../../Controlls/EditViews/LeitsetlleEdit';
import {PopUpView} from '../../../../Componente/PopUpView';
import {Leitstelle} from '../../../../Api/DcoApi/Admin/AdminClasses2';
import {
  EditSubscriptionPartner,
  EditSubscriptionPartnerPopup
} from '../../Controlls/edit-subscription-partner/edit-subscription-partner';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap/modal';
import {ConfirmDialog} from '../../../../Akte/Popups/ConfirmDialog';
import {AddSubscription} from '../../Controlls/add-subscription/add-subscription';
import {
  authorizationConfig,
  SubscriptionAuthorization
} from '../../Controlls/subscription-authorization/subscription-authorization';
import {RestClient} from '../../../../Api/DcoApi/Client/RestClient';

@Component({
  selector: 'subscription-list',
  imports: [
    DataGridView,
    DataGridViewCollumn,
    LeitsetlleEdit,
    PopUpView,
    EditSubscriptionPartner
  ],
  templateUrl: './subscription-list.html',
  styleUrl: './subscription-list.css',
})
export class SubscriptionList {
  @ViewChild('Grid') childComponent!: DataGridView<Leitstelle>;
  private modalService = inject(NgbModal);
  Client: RestClient = new RestClient();
  triggerReload() {
    // Call the child component's function safely
    this.childComponent.LoadData();
  }

  EditPartner(id:string)
  {
    var modal = this.modalService.open(EditSubscriptionPartnerPopup);
    modal.componentInstance.Id = id;
    modal.update({ size: 'Dialog' });
    modal.componentInstance.init();
    modal.closed.subscribe(async b => {

      await this.triggerReload();

    });
    modal.dismissed.subscribe(async b => {

      await this.triggerReload();

    });
  }

  async toggleOnOf(id:string)
  {
    await this.Client.Put<any, any>(`/Backend/Api/V2/Admin/PushSubscription/${id}/IsActive`, null);
    await this.triggerReload();
  }

  EditAuth(edit:any)
  {
    var modal = this.modalService.open(SubscriptionAuthorization);
    modal.update({ size: 'Dialog' });
    modal.componentInstance.authModel = {
      authType: edit.authType,
      username: edit.authConfig?.username,
      password: edit.authConfig?.password,
      token:edit.authConfig?.token,
      hmacSecret: edit.authConfig?.hmacSecret,
      hmacHeaderName: edit.authConfig?.hmacHeaderName,
      apiKeyName: edit.authConfig?.apiKeyName,
      apiKeyValue: edit.authConfig?.apiKeyValue,
      oAuthGrantType: edit.authConfig?.oAuthGrantType,
      oAuthTokenUrl: edit.authConfig?.oAuthTokenUrl,
      oAuthClientId: edit.authConfig?.oAuthClientId,
      oAuthClientSecret: edit.authConfig?.oAuthClientSecret,
      oAuthScope: edit.authConfig?.oAuthScope,
      oAuthUsername: edit.authConfig?.oAuthUsername,
      oAuthPassword: edit.authConfig?.oAuthPassword,
      oAuthRefreshToken: edit.authConfig?.oAuthRefreshToken,
      clientCertificateThumbprint: edit.authConfig?.clientCertificateThumbprint,
      customHeaders:  edit.authConfig?.customHeaders?.map( (header:any) => {
        var key = header.headerKey
        var value =  header.headerValue;
        return { key,value } as Record<string, string>
      } ) ?? []
    } as authorizationConfig;
    modal.componentInstance.isNew = edit.authConfig == undefined || edit.authConfig == null;
    modal.componentInstance.Id = edit.id;

    modal.closed.subscribe(async b => {

      await this.triggerReload();

    });
    modal.dismissed.subscribe(async b => {

      await this.triggerReload();

    });
  }



  AddNew()
  {
    var modal = this.modalService.open(AddSubscription);
    modal.update({ size: 'Dialog' });
   modal.closed.subscribe(async b => {

        await this.triggerReload();

    });
   modal.dismissed.subscribe(async b => {

      await this.triggerReload();

  });
  }

}
